export default function OfferBanner() {
  return (
    <div data-testid="offer-banner" className="relative mt-[72px] bg-ink border-b border-signal/40 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-4 flex items-center justify-center gap-3 md:gap-5 text-center">
        <span className="inline-block w-2.5 h-2.5 bg-signal rotate-45 shrink-0" aria-hidden="true" />
        <p className="font-display uppercase font-black text-base md:text-xl tracking-wide text-signal">
          Offer — 25% off on every one-way journey
        </p>
        <span className="inline-block w-2.5 h-2.5 bg-signal rotate-45 shrink-0" aria-hidden="true" />
      </div>
      <span className="offer-shine" aria-hidden="true" />
    </div>
  );
}
